import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('../layout.vue'),
    redirect: { name: 'blank' },
    children: [
      {
        path: "/blank",
        name: "blank",
        component: () => import('../views/blank/blank.vue')
      },
      // {
      //   path: "/indexlogin",
      //   name: "indexlogin",
      //   component: () => import('../views/login/index.vue')
      // },
      // {
      //   path: "/indexexcessive",
      //   name: "indexexcessive",
      //   component: () => import('../views/login/indexexcessive.vue')
      // },
      // {
      //   path: "/success",
      //   name: "success",
      //   component: () => import('../views/login/success.vue')
      // },
      //商品详情
      {
        path: "/index0",
        name: "index0",
        component: () => import('../views/index0/index0.vue')
      },
      //瀑布流文章详情
      {
        path: "/index1",
        name: "index1",
        component: () => import('../views/index1/index1.vue')
      },

      {
        path: "/index2",
        name: "index2",
        component: () => import('../views/index2/index2.vue')
      },
      //下载页面
      {
        path: "/index10",
        name: "index10",
        component: () => import('../views/index10/index10.vue')
      },
      //隐私协议
      {
        path: "/ysxy",
        name: "ysxy",
        component: () => import('../views/ysxy/ysxy.vue')
      },
      //用户协议
      {
        path: "/yhxy",
        name: "yhxy",
        component: () => import('../views/yhxy/yhxy.vue')
      },
      //乡村详情页
      {
        path: "/index3",
        name: "index3",
        component: () => import('../views/index3/index3.vue')
      },

      {
        path: "/index4",
        name: "index4",
        component: () => import('../views/index4/index4.vue')
      },
      //农业知识详情
      {
        path: "/index5",
        name: "index5",
        component: () => import('../views/index5/index5.vue')
      },
      //书记公开信/三务公开详情
      {
        path: "/index6",
        name: "index6",
        component: () => import('../views/index6/index6.vue')
      },
      // 说事详情&书记交办详情
      {
        path: "/index7",
        name: "index7",
        component: () => import("../views/index7/index7.vue"),
      },
      // 乡村治理
      {
        path: "/index8",
        name: "index8",
        component: () => import("../views/index8/index8.vue"),
      },
      // 乡村治理
      {
        path: "/index12",
        name: "index12",
        component: () => import("../views/index12/index12.vue"),
      },
      //族谱
      {
        path: "/index11",
        name: "index11",
        component: () => import("../views/pedigree/index11.vue"),
      },
      //族谱加密页
      {
        path: "/index13",
        name: "index13",
        component: () => import("../views/pedigree/index13.vue"),
      },
      // 族谱--菜单页
      {
        path: "/index15",
        name: "index15",
        component: () => import("../views/index15/index15.vue"),
      },
      // 族谱--文章分享
      {
        path: "/index14",
        name: "index14",
        component: () => import("../views/index14/index14.vue"),
      },
      {
        path: "/index16",
        name: "index16",
        component: () => import("../views/travel/index16.vue"),
      },
      {
        path: "/index17",
        name: "index17",
        component: () => import("../views/travel/index17.vue"),
      },
      {
        path: "/index18",
        name: "index18",
        component: () => import("../views/travel/index18.vue"),
      },
      {
        path: "/index19",
        name: "index19",
        component: () => import("../views/travel/index19.vue"),
      },
      {
        path: "/index20",
        name: "index20",
        component: () => import("../views/index20/index20.vue"),
      },
      {
        path: "/index21",
        name: "index21",
        component: () => import("../views/index21/index21.vue"),
      },
      //积分详情页

      {
        path: "/index22",
        name: "index22",
        component: () => import("../views/index22/index22.vue"),
      },
      {
        path: "/index23",
        name: "index23",
        component: () => import("../views/index23/index23.vue"),
      },
      // 乡村文化
      {
        path: "/index24",
        name: "index24",
        component: () => import("../views/index24/index24.vue"),
      },
      //
      {
        path: "/aliAuthCallback",
        name: "aliAuthCallback",
        component: () => import("../views/aliAuthCallback/aliAuthCallback.vue"),
      }
    ]
  },
]

const router = new VueRouter({
   mode:'history',
  routes
})
// // 路由拦截
// router.beforeEach((to,from,next) =>{
//     next()
// })
export default router




// WEBPACK FOOTER //
// ./src/router/index.js